/* Search overlay for the Erojoy nav. See sections/ejh-nav.liquid. */
(function () {
  var root = document.querySelector('[data-ejs]');
  if (!root || root.hasAttribute('data-ejs-ready')) { return; }
  root.setAttribute('data-ejs-ready', '');
  var input = root.querySelector('[data-ejs-input]');
  var results = root.querySelector('[data-ejs-results]');
  var timer = null, lastQ = '', ctrl = null, opener = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) { var n = parseFloat(v); if (isNaN(n)) { return ''; } return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }

  function open(e) {
    if (e) { e.preventDefault(); opener = e.currentTarget; }
    root.hidden = false;
    document.documentElement.classList.add('ejs-open');
    window.requestAnimationFrame(function () { root.classList.add('is-open'); input.focus(); });
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('ejs-open');
    window.setTimeout(function () { root.hidden = true; }, 180);
    if (opener && opener.focus) { opener.focus(); }
  }

  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var prods = r.products || [], cols = r.collections || [];
    var html = '';
    if (cols.length) {
      html += '<p class="ejs__h">Collections</p><div class="ejs__cols">';
      cols.slice(0, 4).forEach(function (c) { html += '<a class="ejs__col" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; });
      html += '</div>';
    }
    if (prods.length) {
      html += '<p class="ejs__h">Products</p><ul class="ejs__list">';
      prods.slice(0, 6).forEach(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        if (img) { img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
        html += '<li><a class="ejs__item" href="' + esc(p.url) + '">' +
          (img ? '<img class="ejs__img" src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="ejs__img"></span>') +
          '<span class="ejs__name">' + esc(p.title) + '</span>' +
          '<span class="ejs__price">' + esc(money(p.price)) + '</span></a></li>';
      });
      html += '</ul>';
    }
    if (!prods.length && !cols.length) { html = '<p class="ejs__empty">Nothing matches &ldquo;' + esc(q) + '&rdquo; yet.</p>'; }
    html += '<a class="ejs__all" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for &ldquo;' + esc(q) + '&rdquo; &rarr;</a>';
    results.innerHTML = html;
  }

  function search() {
    var q = input.value.trim();
    if (q === lastQ) { return; }
    lastQ = q;
    if (!q) { results.innerHTML = ''; return; }
    if (ctrl && ctrl.abort) { ctrl.abort(); }
    ctrl = window.AbortController ? new AbortController() : null;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); })
      .then(function (d) { if (input.value.trim() === q) { render(q, d); } })
      .catch(function () {});
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-ejs-open]'), function (a) { a.addEventListener('click', open); });
  Array.prototype.forEach.call(root.querySelectorAll('[data-ejs-close]'), function (b) { b.addEventListener('click', close); });
  input.addEventListener('input', function () { window.clearTimeout(timer); timer = window.setTimeout(search, 180); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) { close(); } });
}());
